<button
  [id]="id"
  mat-flat-button
  class="flex items_center px-2 w_full justify_center mx-1"
  style="height: 35px"
  [disabled]="disabled || loading"
  [ngClass]="{
    'dxf-btn-primary': type === 'primary',
    'dxf-btn-green': type === 'success',
    'dxf-btn-black': type === 'black',
    'dxf-btn-red': type === 'error',
    'dxf-btn-blue-dark': type === 'dark-info',
    'dxf-btn-orange': type === 'warning',
    'dxf-btn-blue': type === 'info',
    'dxf-btn-gray': type === 'dark',
    'dxf-btn-new-green': type === 'newSuccess',
    'dxf-btn-light': type === 'light',
    'new-orange': type === 'reminder',
    'dxf-btn-outline-primary': type === 'outline-primary',
    'dxf-btn-secondary': type === 'secondary',
    'rounded-buttons': withRoundedCorners,
    'cursor_wait opacity-50': loading,
    'cursor_disabled': disabled,
    disabled: disabled && !loading
  }"
  [class]="'text_' + textSize"
  [class.shadow_md]="shadow"
  [matTooltip]="tooltip"
  >
  @if (loading && withSpinner) {
    <mat-spinner class="mat-spinner-sm"></mat-spinner>
  }
  <span
    [ngClass]="{
      'mr-2': icon,
      disabled: disabled,
      pointer: !disabled,
      bold: textBold
    }"
    >{{ buttonName }}</span>
  @if (icon && !loading) {
    <i [class]="icon" class="mr-2"></i>
  }
  @if (!text) {
    <ng-content></ng-content>
  }
  @if (asMenu) {
    <mat-icon class="expand"> expand_more </mat-icon>
  }
</button>
